import { render } from "./MonthlyPotAnnouncement.vue?vue&type=template&id=b23c09ae&scoped=true"
import script from "./MonthlyPotAnnouncement.vue?vue&type=script&lang=js"
export * from "./MonthlyPotAnnouncement.vue?vue&type=script&lang=js"

import "./MonthlyPotAnnouncement.vue?vue&type=style&index=0&id=b23c09ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b23c09ae"]])

export default __exports__